import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["afterSubmit", "allowNull", "beforeSubmit", "children", "component", "defaultValue", "format", "formatOnBlur", "initialValue", "isEqual", "multiple", "name", "parse", "subscription", "type", "validate", "validateFields", "value", "hintInfo", "hintWarning", "hintError"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.function.name.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Context } from './context';
import { TipLevels, VALIDATION_TYPE_REQUIRED } from '@unitedtraders/validators';
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var FinalFormField = function FinalFormField(_ref) {
  var afterSubmit = _ref.afterSubmit,
    allowNull = _ref.allowNull,
    beforeSubmit = _ref.beforeSubmit,
    children = _ref.children,
    component = _ref.component,
    defaultValue = _ref.defaultValue,
    format = _ref.format,
    formatOnBlur = _ref.formatOnBlur,
    initialValue = _ref.initialValue,
    isEqual = _ref.isEqual,
    multiple = _ref.multiple,
    name = _ref.name,
    parse = _ref.parse,
    subscription = _ref.subscription,
    type = _ref.type,
    validate = _ref.validate,
    validateFields = _ref.validateFields,
    value = _ref.value,
    hintInfo = _ref.hintInfo,
    hintWarning = _ref.hintWarning,
    hintError = _ref.hintError,
    rest = _objectWithoutProperties(_ref, _excluded);
  var field = useField(name, {
    afterSubmit: afterSubmit,
    allowNull: allowNull,
    beforeSubmit: beforeSubmit,
    defaultValue: defaultValue,
    format: format,
    formatOnBlur: formatOnBlur,
    initialValue: initialValue,
    isEqual: isEqual,
    multiple: multiple,
    parse: parse,
    subscription: subscription,
    type: type,
    validate: validate,
    validateFields: validateFields,
    value: value
  });
  var _field$meta = field.meta,
    active = _field$meta.active,
    error = _field$meta.error,
    touched = _field$meta.touched;
  var submitError = field.meta.submitError;
  var _useContext = useContext(Context),
    tips = _useContext.tips,
    submittedAtLeastOneTime = _useContext.submittedAtLeastOneTime,
    i18NamespaceForServerErrors = _useContext.i18NamespaceForServerErrors;
  var tip = tips && tips[name];
  var hints = {};
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useTranslation2 = useTranslation(i18NamespaceForServerErrors),
    tServer = _useTranslation2.t;
  if (tip) {
    var translatedTip = t(tip.key, tip.options);
    switch (tip === null || tip === void 0 ? void 0 : tip.level) {
      case TipLevels.TIP:
        hints.hintInfo = active ? translatedTip : undefined;
        break;
      case TipLevels.WARNING:
        hints.hintWarning = translatedTip;
        break;
      default:
        break;
    }
  }
  if (error) {
    var _error$options;
    var _hintError = error.key === VALIDATION_TYPE_REQUIRED || (_error$options = error.options) !== null && _error$options !== void 0 && _error$options.showOnlyAfterSubmit ? submittedAtLeastOneTime && tServer(error.key, error.options) : touched && tServer(error.key, error.options);
    hints.hintError = _hintError;
  }
  if (hintInfo) {
    hints.hintInfo = active && hintInfo;
  }
  if (hintWarning) {
    hints.hintWarning = hintWarning;
  }
  if (hintError) {
    hints.hintError = touched && submittedAtLeastOneTime && hintError;
  }
  if (submitError) {
    if (_typeof(submitError) === 'object') {
      hints.hintError = tServer(submitError.message, submitError.details);
    } else {
      hints.hintError = tServer(submitError);
    }
  }
  if (component) {
    return /*#__PURE__*/React.createElement(component, _objectSpread(_objectSpread(_objectSpread({}, field), rest), hints));
  }
  if (typeof children !== 'function') {
    throw new Error("Must specify either a render prop, a render function as children, or a component prop to ".concat(name));
  }
  return _jsx(_Fragment, {
    children: children(_objectSpread(_objectSpread(_objectSpread({}, field), rest), hints))
  });
};
//# sourceMappingURL=FinalFormField.js.map